import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

const formatSimbolo = (value, simbolo = "€") =>
    `${new Intl.NumberFormat("es-ES", {
        maximumFractionDigits: 0,
    }).format(value)} ${simbolo}`;

const GroupedBarChartGraph = ({
    data,
    series,
    yTicks = [],
    yFormatter = (v) => v,
    height = 400,
    tooltipFormatter,
    simbolo = "€",
}) => {
    const displayData = Array.isArray(data) ? data : [];

    if (!displayData.length) {
        return (
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#777",
                    fontSize: "14px",
                }}
            >
                No hay datos disponibles
            </div>
        );
    }

    const maxValue = Math.max(...yTicks, 1);

    const hasTicks = Array.isArray(yTicks) && yTicks.length > 0;
    const yDomain = hasTicks
        ? [Math.min(...yTicks, 0), Math.max(...yTicks, 0)]
        : [0, maxValue];
    const yTickValues = hasTicks ? yTicks : undefined;

    return (
        <div
            style={{
                width: "100%",
                height,
                position: "relative",
            }}
        >
            <ResponsiveContainer
                width="100%"
                height={height}
                minWidth={0}
                minHeight={0}
            >
                <BarChart
                    data={displayData}
                    margin={{ top: 10, right: 16, left: 0, bottom: 10 }}
                    barGap={4}
                    barCategoryGap="25%"
                >
                    <CartesianGrid
                        vertical={false}
                        strokeDasharray="3 3"
                        stroke="#f0f0f0"
                    />
                    <XAxis
                        dataKey="name"
                        tick={{ fontSize: 14, fill: "#666" }}
                        axisLine={false}
                        tickLine={false}
                    />
                    <YAxis
                        type="number"
                        domain={yDomain}
                        ticks={yTickValues}
                        tickCount={yTicks.length}
                        tick={{ fontSize: 14, fill: "#666" }}
                        tickFormatter={yFormatter}
                        axisLine={false}
                        tickLine={false}
                        width={50}
                        allowDataOverflow
                    />
                    <Tooltip
                        formatter={
                            tooltipFormatter ??
                            ((value, name) => [formatSimbolo(value, simbolo), name])
                        }
                        contentStyle={{
                            backgroundColor: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            fontSize: "14px",
                        }}
                        labelStyle={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#333",
                            marginBottom: "8px",
                        }}
                    />
                    {series.map((s) => (
                        <Bar
                            key={s.key}
                            dataKey={s.key}
                            name={s.name}
                            fill={s.color}
                            radius={[4, 4, 0, 0]}
                        />
                    ))}
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default GroupedBarChartGraph;
